var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { MailDeliveryService } from './mail-delivery.service';
import { ContentBaseComponent } from '../base/contentbase.component';
var MailDeliveryComponent = /** @class */ (function (_super) {
    __extends(MailDeliveryComponent, _super);
    function MailDeliveryComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        // 1コンポーネント複数APIのためnameを固定で分ける
        _this.masterCompName = 'MailDeliveryMComp';
        _this.contentCompName = 'MailDeliveryContentMComp';
        _this.readonly = false;
        _this.isEntry = false;
        _this.mailMasterRequest = Object.assign(new MailMasterRequest());
        _this.mailContentRequest = [];
        _this.copyMailMasterId = 0;
        _this.mailMasterData = [];
        _this.mailSendType = [];
        _this.mailDestination = [];
        _this.mailSendable = [];
        _this.mailSendIncludeLower = [];
        _this.mailSegment = [];
        _this.mailTrigger = [];
        _this.langList = [];
        _this.langs = [];
        _this.contents = [];
        _this.disp = new Disp;
        _this.langErr = false;
        return _this;
    }
    MailDeliveryComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.modal = this.remodalElement.nativeElement;
    };
    MailDeliveryComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        this.getList();
    };
    MailDeliveryComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    MailDeliveryComponent.prototype.onModeSubscribe = function (mode) {
        var _this = this;
        this.readonly = false;
        this.isEntry = false;
        if (mode === 'confirm') {
            this.changeDisp('content', 'text');
            this.readonly = true;
        }
        // コピーは新規登録のみ
        if (mode === 'entry') {
            this.isEntry = true;
            // メール配信マスタ
            this.service.getMailDeliveryMList().subscribe(function (rec) {
                if (rec instanceof Array) {
                    _this.mailMasterData = rec;
                }
            });
        }
    };
    MailDeliveryComponent.prototype.onSubscribe = function (data) {
        // 詳細画面用の初期値反映
        if (data.id) {
            this.mailMasterRequest.id = data.id;
            this.setMailMasterData(data);
            for (var _i = 0, _a = data.mail_delivery_content_m; _i < _a.length; _i++) {
                var content = _a[_i];
                this.contents[content.lang].id = content.id;
            }
            this.setContentsData();
        }
    };
    // 詳細画面表示　及び　コピー反映用
    MailDeliveryComponent.prototype.setMailMasterData = function (data) {
        this.mailMasterRequest.sender_email_id = data.sender_email_id;
        this.mailMasterRequest.replay_email_id = data.replay_email_id;
        this.mailMasterRequest.segment_id = data.segment_id;
        this.mailMasterRequest.is_sendable = data.is_sendable;
        this.mailMasterRequest.send_include_lower = data.send_include_lower;
        this.mailMasterRequest.send_type = data.send_type;
        this.mailMasterRequest.test_address = data.test_address;
        this.mailMasterRequest.send_datetime = data.send_datetime;
        this.mailMasterRequest.trigger_id = data.trigger_id;
        // 取得データを元に選択済とするので一旦チェックを全て外す
        this.langs = [];
        for (var i = 0; i < this.langList.length; i++) {
            this.langList[i].checked = false;
        }
        for (var _i = 0, _a = data.mail_delivery_content_m; _i < _a.length; _i++) {
            var content = _a[_i];
            this.langs.push(content.lang);
            for (var i = 0; i < this.langList.length; i++) {
                if (this.langList[i].lang === content.lang) {
                    this.langList[i].checked = true;
                }
            }
            this.contents[content.lang].title = content.title;
            this.contents[content.lang].contents_text = content.contents_text;
            this.contents[content.lang].contents_html = content.contents_html;
        }
        // 登録済言語の先頭を選択済として表示する
        for (var i = 0; i < this.langList.length; i++) {
            if (this.langList[i].checked = true) {
                this.disp.lang = this.langList[i].lang;
                break;
            }
        }
    };
    // @Override
    MailDeliveryComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    MailDeliveryComponent.prototype.trackByLang = function (index, lang) {
        return lang.lang;
    };
    // 各種マスタ情報取得
    MailDeliveryComponent.prototype.getList = function () {
        var _this = this;
        var emptyOptions = [];
        emptyOptions.push({ code: '', display: '' });
        // 送信者／返信先
        this.service.getMailDestination().subscribe(function (rec) {
            if (rec instanceof Array) {
                _this.mailDestination = rec;
            }
            if (_this.mailDestination.length == 0) {
                _this.mailDestination = emptyOptions;
            }
        });
        // セグメント
        this.service.getSegmentM().subscribe(function (rec) {
            if (rec instanceof Array) {
                _this.mailSegment = rec;
            }
            if (_this.mailSegment.length == 0) {
                _this.mailSegment = emptyOptions;
            }
        });
        this.langList = [];
        this.service.getLanguageList().subscribe(function (rec) {
            if (rec instanceof Array) {
                for (var _i = 0, rec_1 = rec; _i < rec_1.length; _i++) {
                    var lang = rec_1[_i];
                    _this.langList.push(Object.assign(new Language(), lang));
                }
            }
            _this.setLangData();
            _this.setContents();
        });
        // 配信タイミング
        this.service.getSendType().subscribe(function (rec) {
            if (rec instanceof Array) {
                _this.mailSendType = rec;
            }
        });
        // 配信ステータス
        this.service.getIsSendable().subscribe(function (rec) {
            if (rec instanceof Array) {
                _this.mailSendable = rec;
            }
        });
        // 配信対象テナント
        this.service.getSendIncludeLower().subscribe(function (rec) {
            if (rec instanceof Array) {
                _this.mailSendIncludeLower = rec;
            }
        });
        // トリガー
        this.service.getTriggerM().subscribe(function (rec) {
            if (rec instanceof Array) {
                _this.mailTrigger = rec;
            }
            if (_this.mailTrigger.length == 0) {
                _this.mailTrigger = emptyOptions;
            }
        });
    };
    // 他のメールマスタからコピー
    MailDeliveryComponent.prototype.copyMailMaster = function (id) {
        var _this = this;
        if (id === 0) {
            return;
        }
        this.service.getMailDeliveryM(id).subscribe(function (rec) {
            if (typeof rec !== 'undefined') {
                // 配信ステータスは固定で準備中にしておく
                rec.is_sendable = false;
                _this.setMailMasterData(rec);
                _this.setContentsData();
            }
        });
    };
    MailDeliveryComponent.prototype.setLangData = function () {
        this.langs = [];
        for (var _i = 0, _a = this.langList; _i < _a.length; _i++) {
            var lang = _a[_i];
            lang.checked = this.langs.indexOf(lang.lang) >= 0 ? true : false;
        }
        // 言語が未選択の場合は1つ目の言語をセットする
        if (this.langs.length === 0) {
            this.langList[0].checked = true;
            this.langs.push(this.langList[0].lang);
        }
        for (var _b = 0, _c = this.langList; _b < _c.length; _b++) {
            var lang = _c[_b];
            if (lang.checked) {
                this.disp.lang = lang.lang;
                break;
            }
        }
    };
    MailDeliveryComponent.prototype.setContents = function (mode) {
        for (var _i = 0, _a = this.langList; _i < _a.length; _i++) {
            var lang = _a[_i];
            if (typeof this.contents[lang.lang] === 'undefined') {
                this.contents[lang.lang] = Object.assign(new Content(), {
                    lang_code: lang.lang,
                    title: '',
                    contents_text: '',
                    contents_html: ''
                });
            }
        }
        this.changeContents();
    };
    MailDeliveryComponent.prototype.openRemodal = function () {
        this.langErr = false;
        this.remodal = $(this.modal).remodal({ hashTracking: false, closeOnEscape: false, closeOnOutsideClick: false });
        this.remodal.open();
    };
    MailDeliveryComponent.prototype.cancelRemodal = function () {
        for (var _i = 0, _a = this.langList; _i < _a.length; _i++) {
            var lang = _a[_i];
            if ((lang.checked && this.langs.indexOf(lang.lang) == -1) || (!lang.checked && this.langs.indexOf(lang.lang) >= 0)) {
                lang.checked = !lang.checked;
            }
        }
    };
    MailDeliveryComponent.prototype.closeRemodal = function () {
        this.langErr = true;
        for (var _i = 0, _a = this.langList; _i < _a.length; _i++) {
            var lang = _a[_i];
            if (lang.checked) {
                this.disp.lang = lang.lang;
                this.langErr = false;
                break;
            }
        }
        if (!this.langErr) {
            this.changeContents();
            this.remodal.close();
        }
    };
    MailDeliveryComponent.prototype.changeContents = function () {
        this.langs = [];
        for (var _i = 0, _a = this.langList; _i < _a.length; _i++) {
            var lang = _a[_i];
            var deleteFlg = true;
            var content = this.contents[lang.lang];
            if (content) {
                content.delete = deleteFlg;
            }
            else {
                if (lang.checked) {
                    this.contents[lang.lang] = Object.assign(new Content(), {
                        lang_code: lang.lang,
                        delete: deleteFlg
                    });
                }
            }
            if (lang.checked && this.langs.indexOf(lang.lang) == -1) {
                this.langs.push(lang.lang);
            }
        }
        this.setContentsData();
    };
    MailDeliveryComponent.prototype.changeDisp = function (key, val) {
        this.disp[key] = val;
    };
    MailDeliveryComponent.prototype.setContentsData = function () {
        var data = [];
        for (var _i = 0, _a = this.langList; _i < _a.length; _i++) {
            var lang = _a[_i];
            var cont = this.contents[lang.lang];
            var r = new MailContentRequest();
            if (typeof cont.id !== 'undefined') {
                r.id = cont.id;
                r.$type = "put" /* Put */;
            }
            if (typeof cont.id === 'undefined' && this.langs.indexOf(lang.lang) == -1) {
                // 新規登録で選択されていない言語
                continue;
            }
            else if (typeof cont.id !== 'undefined' && this.langs.indexOf(lang.lang) == -1) {
                // 登録済みコンテンツの言語を削除した
                r.$type = "delete" /* Delete */;
                cont.contents_html = '';
                cont.contents_text = '';
            }
            r.contents_html = cont.contents_html;
            r.contents_text = cont.contents_text;
            r.lang = cont.lang_code;
            r.title = cont.title;
            data.push(r);
        }
        this.action.setCompRec(this.contentCompName, { items: data });
    };
    // @TODO 未完成（日時配信／トリガー配信）
    MailDeliveryComponent.prototype.onChange = function (e, key, lang) {
        // 配信タイミングを変更された場合は一旦リセットして再セット
        if (key === 'send_type') {
            this.mailMasterRequest['send_datetime'] = '';
            this.mailMasterRequest['trigger_id'] = '';
        }
        if (key === 'contents_html') {
            this.contents[this.disp.lang].contents_html = e.val;
            this.setContentsData();
        }
        else if (key === 'contents_text') {
            this.contents[this.disp.lang].contents_text = e.val;
            this.setContentsData();
        }
        else if (key === 'title') {
            this.contents[this.disp.lang].title = e.val;
            this.setContentsData();
        }
        else {
            this.mailMasterRequest[key] = e.val;
        }
        // 即時配信完了の場合は送信前にアラート表示する
        if (this.mailMasterRequest['send_type'] === 'immediate' && this.mailMasterRequest['is_sendable'] === 'true') {
            this.mailMasterRequest['show_alert'] = true;
        }
        else {
            this.mailMasterRequest['show_alert'] = false;
        }
        this.action.setCompRec(this.masterCompName, this.mailMasterRequest);
    };
    MailDeliveryComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if ($(this.modal).parent().hasClass('remodal-wrapper')) {
            this.remodal.destroy();
        }
    };
    MailDeliveryComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'mail-delivery',
                    template: "<form id=\"{{ componentName }}\">\n  <div *ngIf=\"isEntry\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\">\n          <column-formtitle [key]=\"'form'\" [col]=\"{label: (msg | async)['MailDeliveryConponent.item.sentData']}\" [msg]=\"(msg | async)\"></column-formtitle>\n        </dt>\n      </dl>\n      <dl class=\"form -mb-3\">\n        <dd class=\"form_dd\">\n          <ul>\n            <li class=\"form_li\">\n              <select [(ngModel)]=\"copyMailMasterId\" name=\"mailMasterList\" class=\"formSelect\">\n                <option [ngValue]=\"0\" [selected]=\"copyMailMasterId === 0\">--{{ (msg | async)['MailDeliveryConponent.item.sentData'] }}--</option>\n                <option *ngFor=\"let option of mailMasterData; trackBy: trackByOption\" [ngValue]=\"option.code\">{{ option.display }}</option>\n              </select>\n            </li>\n            <li class=\"form_li\">\n              <ul>\n                <li>\n                  <button class=\"btn\" (click)=\"copyMailMaster(copyMailMasterId); changeDisp('content', 'text');\">{{ (msg | async)['MailDeliveryConponent.item.copy'] }}</button>\n                </li>\n              </ul>\n            </li>\n          </ul>\n        </dd>\n      </dl>\n    </div>\n    <horizontal-rule></horizontal-rule>\n    <dl class=\"form -mb-3\"></dl>\n  </div>\n\n  <dl class=\"form -mb-3\">\n    <dt class=\"form_dt\">\n      <column-formtitle [key]=\"'form'\" [col]=\"{label: (msg | async)['MailDeliveryConponent.item.sender_email_id'], required: true} \" [msg]=\"(msg | async)\">\n      </column-formtitle>\n    </dt>\n    <dd class=\"form_dd\">\n      <ul>\n        <li class=\"form_li-w50per\" *ngIf=\"mailDestination.length > 0\">\n          <column-select *ngIf=\"!readonly\" [key]=\"'form'\" [col]=\"{\n                key: componentName + '.sender_email_id',\n                controlType: 'select',\n                required: true,\n                params: {options: mailDestination}\n              }\" [val]=\"mailMasterRequest.sender_email_id\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'sender_email_id')\">\n          </column-select>\n          <column-formreadonly *ngIf=\"readonly\" [col]=\"{\n              controlType: 'select',\n              params: {options: mailDestination}\n            }\" [val]=\"mailMasterRequest.sender_email_id\" [msg]=\"(msg | async)\">\n          </column-formreadonly>\n        </li>\n      </ul>\n    </dd>\n  </dl>\n  <dl class=\"form -mb-3\">\n    <dt class=\"form_dt\">\n      <column-formtitle [key]=\"'form'\" [col]=\"{label: (msg | async)['MailDeliveryConponent.item.replay_email_id'], required: true}\" [msg]=\"(msg | async)\"></column-formtitle>\n    </dt>\n    <dd class=\"form_dd\">\n      <ul>\n        <li class=\"form_li-w50per\" *ngIf=\"mailDestination.length > 0\">\n          <column-select *ngIf=\"!readonly\" [key]=\"'form'\" [col]=\"{\n                key: componentName + '.replay_email_id',\n                controlType: 'select',\n                required: true,\n                params: {options: mailDestination}\n              }\" [val]=\"mailMasterRequest.replay_email_id\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'replay_email_id')\">\n          </column-select>\n          <column-formreadonly *ngIf=\"readonly\" [col]=\"{\n              controlType: 'select',\n              params: {options: mailDestination}\n            }\" [val]=\"mailMasterRequest.replay_email_id\" [msg]=\"(msg | async)\">\n          </column-formreadonly>\n        </li>\n      </ul>\n    </dd>\n  </dl>\n  <dl class=\"form -mb-3\">\n    <dt class=\"form_dt\">\n      <column-formtitle [key]=\"'form'\" [col]=\"{label: (msg | async)['MailDeliveryConponent.item.segment_id'], required: true}\" [msg]=\"(msg | async)\"></column-formtitle>\n    </dt>\n    <dd class=\"form_dd\">\n      <ul>\n        <li class=\"form_li-w75per\" *ngIf=\"mailSegment.length > 0\">\n          <column-select2 *ngIf=\"!readonly\" [key]=\"'form'\" [col]=\"{\n                key: componentName + '.segment_id',\n                controlType: 'select2',\n                required: true,\n              params: {options: mailSegment,formClass: {width: '100'}}\n              }\" [val]=\"mailMasterRequest.segment_id\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'segment_id')\">\n          </column-select2>\n          <column-formreadonly *ngIf=\"readonly\" [col]=\"{\n              controlType: 'select',\n              params: {options: mailSegment}\n            }\" [val]=\"mailMasterRequest.segment_id\" [msg]=\"(msg | async)\">\n          </column-formreadonly>\n        </li>\n      </ul>\n    </dd>\n  </dl>\n\n  <dl class=\"form\">\n    <dt class=\"form_dt\">\n      <column-formtitle [key]=\"'form'\" [col]=\"{label: (msg | async)['MailDeliveryConponent.item.contentsLabel'], required: true}\" [msg]=\"(msg | async)\"></column-formtitle>\n    </dt>\n  </dl>\n\n  <ul class=\"remodal_btns_group\" *ngIf=\"!readonly\">\n    <li>\n      <button class=\"btn\" (click)=\"openRemodal()\">{{ (msg | async)['Component.label.selectLanguage'] }}</button>\n    </li>\n  </ul>\n\n  <div class=\"col-sm-10 formToggle\">\n    <ul class=\"tabsMenu\">\n      <ng-template ngFor let-lang [ngForOf]=\"langList\" [ngForTrackBy]=\"trackByLang\">\n        <li *ngIf=\"langs.indexOf(lang.lang) >= 0\" [class.tabsMenu_current]=\"disp.lang === lang.lang\">\n          <a href=\"javascript:void(0);\" (click)=\"changeDisp('lang', lang.lang); changeDisp('content', 'text');\">{{ lang.label }}</a>\n        </li>\n      </ng-template>\n    </ul>\n    <div *ngIf=\"contents[disp.lang]\" class=\"forms forms-campaign -mt-05 stageFlowPane_border\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\"><label class=\"formLabelText\">{{ (msg | async)['MailDeliveryConponent.item.title'] }}</label></dt>\n        <dd class=\"form_dd\">\n          <column-text *ngIf=\"!readonly\"\n                       [key]=\"'form'\"\n                       [col]=\"{\n                         key: componentName + '.title',\n                         controlType: 'text'\n                       }\"\n                       [msg]=\"(msg | async)\"\n                       [val]=\"contents[disp.lang].title\" (changeVal)=\"onChange($event, 'title')\">\n          </column-text>\n          <column-formreadonly *ngIf=\"readonly\" [col]=\"{controlType: 'textarea'}\" [val]=\"contents[disp.lang].title\" [msg]=\"(msg | async)\"></column-formreadonly>\n        </dd>\n      </dl>\n      <dl class=\"form -mt-2\">\n        <dt class=\"form_dt\"><label class=\"formLabelText\">{{ (msg | async)['MailDeliveryConponent.item.contents'] }}</label></dt>\n        <dd class=\"form_dd\">\n          <ul class=\"tabsMenu2 -mb-05\">\n            <li [class.tabsMenu2_current]=\"disp.content === 'text'\">\n              <a href=\"javascript:void(0);\" (click)=\"changeDisp('content', 'text')\">{{ (msg | async)['Component.label.text'] }}</a>\n            </li>\n            <li [class.tabsMenu2_current]=\"disp.content === 'html'\">\n              <a href=\"javascript:void(0);\" (click)=\"changeDisp('content', 'html')\">{{ (msg | async)['Component.label.html'] }}</a>\n            </li>\n          </ul>\n          <ul *ngIf=\"disp.content === 'html'\">\n            <li class=\"form_li form_li-w100per form_li-h250\">\n              <column-htmleditor\n                  [key]=\"'form'\"\n                  [col]=\"{\n                                   key: componentName + '_' + disp.lang + '.html',\n                                   controlType: 'htmlEditor',\n                                   readonly: readonly\n                                 }\"\n                  [msg]=\"(msg | async)\"\n                  [val]=\"contents[disp.lang].contents_html\" (changeVal)=\"onChange($event, 'contents_html')\">\n              </column-htmleditor>\n            </li>\n          </ul>\n          <ul *ngIf=\"disp.content === 'text'\">\n            <li class=\"form_li form_li-w100per\" *ngIf=\"!readonly\">\n              <column-textarea\n                  [key]=\"'form'\"\n                  [col]=\"{\n                         key: componentName + '_' + disp.lang + '.text',\n                         controlType: 'textarea',\n                         readonly: readonly,\n                         params: { options: { rows: 20 }}\n                       }\"\n                  [msg]=\"(msg | async)\"\n                  [val]=\"contents[disp.lang].contents_text\" (changeVal)=\"onChange($event, 'contents_text')\">\n              </column-textarea>\n            </li>\n          </ul>\n          <ul *ngIf=\"readonly\">\n            <li class=\"form_li form_li-w100per\">\n              <column-formreadonly *ngIf=\"disp.content === 'text'\" [col]=\"{controlType: 'textarea'}\" [val]=\"contents[disp.lang].contents_text\" [msg]=\"(msg | async)\"></column-formreadonly>\n            </li>\n          </ul>\n        </dd>\n      </dl>\n    </div>\n  </div>\n\n  <dl class=\"form -mt-2\">\n    <dt class=\"form_dt\">\n      <column-formtitle [key]=\"'form'\" [col]=\"{label: (msg | async)['MailDeliveryConponent.item.send_include_lower'], required: true}\" [msg]=\"(msg | async)\"></column-formtitle>\n    </dt>\n    <dd class=\"form_dd\">\n      <ul>\n        <li class=\"form_li\">\n          <column-radio *ngIf=\"!readonly\" [key]=\"'form'\" [col]=\"{\n              key: componentName + '.send_include_lower',\n              controlType: 'radio',\n              required: true,\n              params: {options: mailSendIncludeLower}\n            }\" [val]=\"mailMasterRequest.send_include_lower\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'send_include_lower')\">\n          </column-radio>\n          <column-formreadonly *ngIf=\"readonly\" [col]=\"{\n              controlType: 'radio',\n              params: {options: mailSendIncludeLower}\n            }\" [val]=\"mailMasterRequest.send_include_lower\" [msg]=\"(msg | async)\">\n          </column-formreadonly>\n        </li>\n      </ul>\n    </dd>\n  </dl>\n  <dl class=\"form -mt-2\">\n    <dt class=\"form_dt\">\n      <column-formtitle [key]=\"'form'\" [col]=\"{label: (msg | async)['MailDeliveryConponent.item.send_type'], required: true}\" [msg]=\"(msg | async)\"></column-formtitle>\n    </dt>\n    <dd class=\"form_dd\">\n      <ul>\n        <li class=\"form_li\">\n          <column-radio *ngIf=\"!readonly\" [key]=\"'form'\" [col]=\"{\n              key: 'mail_delivery_m.send_type',\n              controlType: 'radio',\n              required: true,\n              params: {options: mailSendType}\n            }\" [val]=\"mailMasterRequest.send_type\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'send_type')\">\n          </column-radio>\n          <column-formreadonly *ngIf=\"readonly\" [col]=\"{\n              controlType: 'radio',\n              params: {options: mailSendType}\n            }\" [val]=\"mailMasterRequest.send_type\" [msg]=\"(msg | async)\">\n          </column-formreadonly>\n        </li>\n      </ul>\n      <!--\u65E5\u6642\u9078\u629E-->\n      <ul>\n        <li class=\"form_li-w300\">\n          <column-datetime *ngIf=\"!readonly && mailMasterRequest.send_type === 'specifydate'\" [key]=\"'form'\" [col]=\"{\n              key: componentName + '.datetime',\n              controlType: 'datetime',\n              required: false,\n              params: { placeholder: (msg | async)['Component.specifydate.placeholder'] }\n            }\" [val]=\"mailMasterRequest.send_datetime\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'send_datetime')\">\n          </column-datetime>\n          <column-formreadonly *ngIf=\"readonly && mailMasterRequest.send_type === 'specifydate'\" [col]=\"{\n              controlType: 'datetime'\n            }\" [val]=\"mailMasterRequest.send_datetime\" [msg]=\"(msg | async)\">\n          </column-formreadonly>\n        </li>\n      </ul>\n      <!--\u30C8\u30EA\u30AC\u30FC\u9078\u629E-->\n      <ul>\n        <li class=\"form_li-w75per\">\n          <column-select2 *ngIf=\"!readonly && mailMasterRequest.send_type === 'trigger'\" [key]=\"'form'\" [col]=\"{\n                key: componentName + '.trigger_id',\n                controlType: 'select2',\n                required: true,\n                params: {options: mailTrigger,formClass: {width: '75per'}}\n              }\" [val]=\"mailMasterRequest.trigger_id\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'trigger_id')\">\n          </column-select2>\n          <column-formreadonly *ngIf=\"readonly && mailMasterRequest.send_type === 'trigger'\" [col]=\"{\n              controlType: 'select',\n              params: {options: mailTrigger}\n            }\" [val]=\"mailMasterRequest.trigger_id\" [msg]=\"(msg | async)\">\n          </column-formreadonly>\n        </li>\n      </ul>\n    </dd>\n  </dl>\n\n  <dl class=\"form -mt-2\">\n    <dt class=\"form_dt\">\n      <column-formtitle [key]=\"'form'\" [col]=\"{label: (msg | async)['MailDeliveryConponent.item.is_sendable'], required: true}\" [msg]=\"(msg | async)\"></column-formtitle>\n    </dt>\n    <dd class=\"form_dd\">\n      <ul>\n        <li class=\"form_li\">\n          <column-radio *ngIf=\"!readonly\" [key]=\"'form'\" [col]=\"{\n                key: componentName + '.is_sendable',\n                controlType: 'radio',\n                required: true,\n                params: {options: mailSendable}\n              }\" [val]=\"mailMasterRequest.is_sendable\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'is_sendable', '', '')\">\n          </column-radio>\n          <column-formreadonly *ngIf=\"readonly\" [col]=\"{\n              controlType: 'radio',\n              params: {options: mailSendable}\n            }\" [val]=\"mailMasterRequest.is_sendable\" [msg]=\"(msg | async)\">\n          </column-formreadonly>\n        </li>\n      </ul>\n    </dd>\n  </dl>\n\n  <dl class=\"form -mt-2\">\n    <dt class=\"form_dt\">\n      <column-formtitle [key]=\"'form'\" [col]=\"{label: (msg | async)['MailDeliveryConponent.item.test_address']}\" [msg]=\"(msg | async)\"></column-formtitle>\n      <p class=\"-note -mt-1\">{{ (msg | async)['MailDeliveryConponent.item.test_address_note'] }}</p>\n    </dt>\n    <dd class=\"form_dd\">\n      <ul>\n        <li class=\"form_li-w75per\">\n          <textarea class=\"formTextArea\" rows=\"5\" *ngIf=\"!readonly\"\n                    id=\"'test_address'\"\n                    name=\"'test_address'\"\n                    [(ngModel)]=\"mailMasterRequest.test_address\"></textarea>\n          <column-formreadonly *ngIf=\"readonly\" [col]=\"{controlType: 'textarea'}\" [val]=\"mailMasterRequest.test_address\" [msg]=\"(msg | async)\">\n          </column-formreadonly>\n        </li>\n      </ul>\n    </dd>\n  </dl>\n\n</form>\n<!-- remodal -->\n<div class=\"remodal\" data-remodal-id=\"stageFlow_lang\" #remodal>\n  <p>{{ (msg | async)['Component.modal.selectLanguage'] }}</p>\n  <ul class=\"remodal_regionList\">\n    <li *ngFor=\"let lang of langList; trackBy: trackByLang\">\n      <input type=\"checkbox\" id=\"contents-{{ lang.lang }}\" name=\"lang\" [checked]=\"lang.checked\" (change)=\"lang.checked=!lang.checked\">\n      <label for=\"contents-{{ lang.lang }}\" class=\"remodal_regionList_btn\">\n        <img class=\"hNav_user_lang_flag\" src=\"{{ lang.img }}\" alt=\"\">{{ lang.label }}\n      </label>\n    </li>\n  </ul>\n  <p *ngIf=\"langErr\" class=\"-comment\">{{ (msg | async)['Component.modal.unselected'] }}</p>\n  <div class=\"remodal_btns\">\n    <ul class=\"remodal_btns_group\">\n      <li>\n        <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\" (click)=\"cancelRemodal()\">{{ (msg | async)['Component.modal.button.cancel'] }}</button>\n      </li>\n      <li>\n        <button type=\"submit\" class=\"remodal_btns_group-ok\" (click)=\"closeRemodal()\">{{ (msg | async)['Component.modal.button.ok'] }}</button>\n      </li>\n    </ul>\n  </div>\n</div>\n<!-- /remodal -->\n"
                }] }
    ];
    /** @nocollapse */
    MailDeliveryComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: MailDeliveryService }
    ]; };
    MailDeliveryComponent.propDecorators = {
        remodalElement: [{ type: ViewChild, args: ['remodal',] }]
    };
    return MailDeliveryComponent;
}(ContentBaseComponent));
export { MailDeliveryComponent };
var Content = /** @class */ (function () {
    function Content() {
        this.delete = false;
        this.title = '';
        this.contents_text = '';
        this.contents_html = '';
    }
    return Content;
}());
var Disp = /** @class */ (function () {
    function Disp() {
        this.content = 'text'; // html, text
    }
    return Disp;
}());
var Language = /** @class */ (function () {
    function Language() {
        this.checked = false;
    }
    return Language;
}());
var MailContentRequest = /** @class */ (function () {
    function MailContentRequest() {
        this.$type = "post" /* Post */;
        this.title = '';
        this.contents_text = '';
        this.contents_html = '';
        this.lang = '';
    }
    return MailContentRequest;
}());
export { MailContentRequest };
var MailMasterRequest = /** @class */ (function () {
    function MailMasterRequest() {
        this.$type = "post" /* Post */;
        this.is_sendable = 'false';
        this.send_type = 'immediate';
        this.show_alert = false;
        this.test_address = '';
        this.send_include_lower = false;
        this.send_datetime = "";
        this.trigger_id = "";
    }
    return MailMasterRequest;
}());
export { MailMasterRequest };
//# sourceMappingURL=mail-delivery.component.js.map